//Autogenerated file - do not modify!
namespace com.keyman.environment {
  export var VERSION = "14.0";
  export var BUILD = 270;
  export var ENVIRONMENT = "stable";
  export var SENTRY_RELEASE = "release-14.0.270";
}

